import { render, staticRenderFns } from "./MioConsent.vue?vue&type=template&id=366e1ef5&"
import script from "./MioConsent.vue?vue&type=script&lang=js&"
export * from "./MioConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports